import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { SelectedCloseHoc, DeleteHoc, SelectedForwardHoc } from "../../../../../../../src/assets/images";
import Modal from "../../../../Common/Modal";
import ForwardPopUp from "../../../PopUp/ForwardPopUp";

export default function ForwardOptions(props = {}) {
  const { 
    msgActionType,
    closeMessageOption, 
    activeJid, 
    deleteMultipleMessages, 
    // handleStarredAction, 
    scrollToBottom
  } = props;

  const stateData = useSelector((state) => state);
  const {
    selectedMessageData: { 
      // id = "", 
      totalMessage = 0, 
      // data = [] 
    } = {}
  } = stateData;

  const [popUpStatus, setPopUpStatus] = useState(false);
  const showForwardPopUp = () => {
    setPopUpStatus(!popUpStatus);
  };

  /**
  // React.useEffect(() => {
  //   if (id && totalMessage === 0) {
  //     closeMessageOption();
  //   }
  // }, [id]);

  // React.useEffect(() => {
  //   if(msgActionType==='Delete'){
  //     return () => {
  //       closeMessageOption();
  //     };
  //   }
  // }, []);

  // const getStarredActionStatus = () => {
  //   let isFavourite = false;
  //   data.map((el) => {
  //     if (el.favouriteStatus === 0) isFavourite = true;
  //     return el.msgId;
  //   });
  //   return isFavourite;
  // };
  */

  return (
    <Fragment>
    {<div className="selectedMessagecontainer">
        <div className="selectedMessageOption">
          <div className="CloseSelectedMessageOption">
            <i onClick={closeMessageOption} title="Close">
              <SelectedCloseHoc viewBox="0 0 18.2 18.201"/>
            </i>
            <span>{totalMessage} Selected</span>
          </div>
          <ul className="selectedForwardOption">
            {msgActionType === "Delete" && (
              <li onClick={deleteMultipleMessages} className="delete" title="Delete">
                <i>
                  <DeleteHoc  viewBox="0 0 18.2 18.201" />
                </i>
              </li>
            )}
            {msgActionType === "Forward" && (
              <li className="forward" data-jest-id="jestShowForwardPopUp" onClick={showForwardPopUp} title="Forward">
                <i>
                  <SelectedForwardHoc viewBox=" 0 0 19 19" />
                </i>
              </li>
            )}

            {/** {(msgActionType === "Starred" || msgActionType === "UnStarred") && (
              <>
                {getStarredActionStatus() ? (
                  <li className="star" title="Add as favourite" onClick={handleStarredAction}>
                    <i>
                      <StarredDarkHoc fill="#383636" />
                    </i>
                  </li>
                ) : (
                  <li className="star" title="Remove from favourite" onClick={handleStarredAction}>
                    <i>
                      <UnStarDarkHoc fill="#383636" />
                    </i>
                  </li>
                )}
              </>
            )} */}
          </ul>
        </div>
      </div>}
      {popUpStatus &&(
        <Modal containerId="container">
          <ForwardPopUp 
            activeJid={activeJid}
            closeMessageOption={closeMessageOption} 
            closePopup={showForwardPopUp} 
            scrollToBottom={scrollToBottom}  
          />
        </Modal>
      )}
    </Fragment>
  );
}
